// *******************************************************************************
// Model Hero
// *******************************************************************************

document.addEventListener('DOMContentLoaded', () => {
  setTimeout(document.querySelector('.model-hero')?.classList.add('is-playing'), 300);
});
